module.exports = __webpack_public_path__ + "img/demo5.8b39dd9d.png";